// Port of api/fuel/app/classes/insights/records/monthly.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function monthStartOffset(monthOffset) {
	var d = new Date()
	d.setUTCDate(1)
	d.setUTCHours(0, 0, 0, 0)
	d.setUTCMonth(d.getUTCMonth() + monthOffset)
	return Math.floor(d.getTime() / 1000)
}

export default Segment.extend({
	name: 'monthly',
	types: [Constants.TYPE_USER],
	requires: ['init'],
	insight: false,
	detail: false,
	run: function() {
		var plays = this._data.plays || []
		var monthly = {
			start: 0,
			end: 0,
			months: {}
		}
		var cutoff = monthStartOffset(-11)

		if (plays.length) {
			monthly.start = (plays[0].date > cutoff) ? parseInt(plays[0].date, 10) : cutoff

			for (var i = 0; i < plays.length; i++) {
				var play = plays[i]
				if (play.date >= cutoff && play.result) {
					var key = Util.date('m', play.date) + '.' + Util.date('Y', play.date)
					if (!monthly.months[key]) monthly.months[key] = { plays: 0, wins: 0 }
					monthly.months[key].plays += parseInt(play.count, 10)
					monthly.months[key].wins += parseInt(play.won, 10)
				}
			}

			monthly.end = parseInt(plays[plays.length - 1].date, 10)
		}

		return {
			monthly: monthly
		}
	}
})
